import React from 'react';
import { useController } from 'react-hook-form';
import { EngineInternalFieldSuffix } from '../../../../../expressions/EngineInternalFieldSuffix';
import { IWidgetComponentProps } from '../../../../IWidgetType';
import { IWidgetParsedProps } from '../../../inputs/common/util/getWidgetProps';
import { ISubsectionWidget } from '../ISubsectionWidget';
import { SubsectionDrawer } from './main-layout/SubsectionDrawer';

export function getHiddenSubsectionControlFieldName(name: string) {
  return `${EngineInternalFieldSuffix}_${name}_hidden_field_controller`;
}

export interface IHiddenSubsectionComponentProps
  extends IWidgetComponentProps<ISubsectionWidget> {
  options: IWidgetParsedProps;
}

export function HiddenSubsectionComponent(
  props: IHiddenSubsectionComponentProps,
) {
  const { widget, options } = props;

  const { field } = useController({
    name: getHiddenSubsectionControlFieldName(options.name),
  });

  return (
    <SubsectionDrawer
      {...props}
      widget={widget}
      isOpen={field.value}
      setIsOpen={(value: boolean) => {
        field.onChange(value);
      }}
    />
  );
}
